// region-token.ts
import { HttpContextToken } from '@angular/common/http';
import { IdentityUserRegion } from '@app/areas/users/models/identity-user.interface';

export const REGION_CTX = new HttpContextToken<IdentityUserRegion | null>(() => null);
